import { LanguageSelector as LanguageSelector1} from "../../Components";
import LanguageSelector2 from "../../Components/languageSelector"
import { Clock } from "../../Components/clock";
import { frames, logos, useMediaQuery } from "../../Styles"
import { Outlet } from "react-router-dom";

const DefLayout = () => {
  const mobile = useMediaQuery(`(max-width: 600px)`);

  return (
    <frames.DecorBg>
      <div style={{position:"absolute", right:"20px", top: "10px", zIndex: "2", display: "flex", alignItems: "center", gap: "20px"}}>
        {/* <LanguageSelector1 overrides={{ isPrimaryComponent: false }}/> */}
        <Clock/>
        <LanguageSelector2 isPrimary={false}/>
      </div>
      <frames.Def>
        <img
          alt="Freeda Logo"
          src={logos.whiteFreedaLogo} 
          style={{
            width: !mobile? "600px" : "80%",
            marginBottom: "20px"
          }}
        />

        <Outlet />
      
      </frames.Def>
    </frames.DecorBg>  
  )
}
 
export default DefLayout